import type {TriggerIntegrationSpec, TriggerIntegrationStruct} from '@cohort/shared/apps/trigger';
import {z} from 'zod';

export const YoutubeLikeTriggerConfigSchema = z.object({
  videoId: z.string().min(1, 'errorRequired'),
  videoTitle: z.string().min(1, 'errorRequired'),
});
export type YoutubeLikeTriggerConfig = z.infer<typeof YoutubeLikeTriggerConfigSchema>;

export const YoutubeLikeVerificationAttemptDataSchema = z.object({
  channelId: z.string().nullable(),
  channelTitle: z.string().nullable(),
  channelHandle: z.string().nullable(),
  videoId: z.string(),
  liked: z.boolean(),
});
export type YoutubeLikeVerificationAttemptData = z.infer<
  typeof YoutubeLikeVerificationAttemptDataSchema
>;

export type YoutubeLikeTriggerStruct = TriggerIntegrationStruct<
  'youtube.like',
  YoutubeLikeTriggerConfig,
  YoutubeLikeVerificationAttemptData
>;
export const YoutubeLikeTriggerSpec: TriggerIntegrationSpec<YoutubeLikeTriggerStruct> = {
  id: 'youtube.like' as const,
  configurableMaxAttempts: false,
  configSchema: YoutubeLikeTriggerConfigSchema,
  verificationAttemptDataSchema: YoutubeLikeVerificationAttemptDataSchema,
  verificationAttemptInputSchema: z.object({}),
  requiresMerchantConnection: true,
  useCases: ['social-media'],
};
